<ng-template #dialogTemplate let-data>
  <section
    class="iconic-dialog madar--v2 bg-white radius-3"
    [class.iconic-dialog--warn]="data.type === data.ConfirmationType?.DestructiveAction"
    [class.iconic-dialog--primary]="data.type === data.ConfirmationType?.NonDestructiveAction"
    [class.iconic-dialog--success]="data.type === data.ConfirmationType?.Informative"
  >
    <header class="iconic-dialog__header px-6 pt-6">
      <div class="flex justify-space-between align-center">
        <h6 *ngIf="data.enableTitle" class="iconic-dialog__title weight-normal text-900 m-0">{{data.headerTitle}}</h6>
        <button mat-dialog-close (click)="data.reject()" [autofocus]="false" tabindex="-1"
          class="iconic-dialog__icon-button flex align-center justify-center p-0"
          type="button" [disabled]="confirmData?.disableCloseDialog">
          <app-icon name="bold-cancel" size="xs"></app-icon>
        </button>
      </div>
      <mat-divider class="iconic-dialog__divider mt-3"></mat-divider>
    </header>
    <mat-dialog-content class="iconic-dialog__body scrollable scollable--y px-6 pt-3 pb-0">
      <p class="iconic-dialog__text h6 text-500 m-0" [innerHTML]="data.message"></p>
      <form [formGroup]="form" *ngIf="form">
        <div class="iconic-dialog__checkbox" *ngIf="form.controls.checkboxOption">
          <mat-checkbox formControlName="checkboxValue" [color]="data.warnAction ? 'warn' : 'primary'">{{data.checkboxOption}}</mat-checkbox>
        </div>
        <div *ngIf="form.controls.textarea" class="iconic-dialog__text-area">
          <label class="iconic-dialog__text-area-label h6 text-900 weight-medium d-block mb-2">{{data.textAreaText}}</label>
          <mat-form-field appearance="outline" class="iconic-dialog__text-area-field">
            <input formControlName="textarea" [placeholder]="'shared.Placeholder.EnterReason' | translate" type="text" matInput />
            <mat-error *ngIf="form?.controls?.textarea.touched && form?.controls?.textarea?.errors?.required">
              {{ "ErrorMessages.Required" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions class="iconic-dialog__actions px-6 pb-6 pt-3">
      <div class="w-100">
        <mat-divider class="iconic-dialog__divider mb-3"></mat-divider>
        <div class="iconic-dialog__buttons flex justify-flex-end wrap">
          <div *ngIf="data.enableCancel">
            <button mat-stroked-button class="d-block iconic-dialog__cancel bg-white radius-2 h6 m-0 weight-normal" (click)="data?.reject()">
              {{data?.cancelActionText ? data?.cancelActionText : 'shared.Buttons.Cancel' | translate }}
            </button>
          </div>
          <div *ngIf="data.enableAction">
            <button
              *ngIf="data.enableAction"
              mat-flat-button
              class="d-block radius-2 h6 m-0 weight-normal"
              [color]="data.type === data.ConfirmationType.DestructiveAction ? 'warn' : data.type === data.ConfirmationType?.Informative? null : 'primary'"
              [ngClass]="{'bg-success text-lightest':data.type === data.ConfirmationType?.Informative}"
              (click)="data?.confirm(data?.checkboxValue)"
            >
              {{data?.mainActionText ? data?.mainActionText : 'shared.Buttons.Confirm' | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-dialog-actions>
  </section>
</ng-template>
